import React, { FC, useEffect, useRef, useState } from 'react';

interface ModalProps {
  modalTitle?: string;
  isOpen: boolean;
  hasCloseBtn?: boolean;
  onClose?: () => void;
  children: React.ReactNode;
}

const Modal: FC<ModalProps> = ({ modalTitle = "", isOpen, hasCloseBtn = true, onClose, children}) => {
  const [isModalOpen, setModalOpen] = useState(isOpen);
  const modalRef = useRef<HTMLDialogElement | null>(null);

  //#region useEffects
  useEffect(() => {
    setModalOpen(isOpen);
  }, [isOpen]);

  useEffect(() => {
    const modalElement = modalRef.current;
    if (modalElement) {
      if (isModalOpen) {
        modalElement.showModal();
      } else {
        modalElement.close();
      }
    }
  }, [isModalOpen]);

  //#endregion useEffect

  //#region functions
  const handleCloseModal = () => {
    if (onClose) {
      onClose();
    }
    setModalOpen(false);
  };
  //escape closes the dialog
  const handleKeyDown = (event: React.KeyboardEvent<HTMLDialogElement>) => {
    if (event.key === "Escape") {
      handleCloseModal();
    }
  };
  //#endregion functions


  return (
    <dialog ref={modalRef} className='modal' onKeyDown={handleKeyDown}>
      <div className='modal-header-container'>
        <h2 className='modal-header-container-title h4-size'>{modalTitle}</h2>
        {hasCloseBtn && (
          <button className='modal-close' onClick={handleCloseModal}>&times;</button>
        )}
      </div>
      {children}
    </dialog>
  );
}



export default Modal;
